module.exports = __webpack_public_path__ + "static/media/validation.2b5326a8.svg";